<template>
    <div class="setting_main_container">
        <slot></slot>
    </div>
</template>